import { render, staticRenderFns } from "./SubPageTabs.vue?vue&type=template&id=1f4cdbf8&scoped=true&"
import script from "./SubPageTabs.vue?vue&type=script&lang=js&"
export * from "./SubPageTabs.vue?vue&type=script&lang=js&"
import style0 from "./SubPageTabs.vue?vue&type=style&index=0&id=1f4cdbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4cdbf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VChip,VItem,VTabsItems})
